import { useMutation } from '@apollo/client';

import UpdateParentCustomerMutation from '@/graphql/contracts/updateParentCustomer.mutation.gql';
import { UpdateParentCustomer, UpdateParentCustomerVariables }
  from '@/graphql/contracts/_generated_/updateParentCustomer.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export default function useUpdateParentCustomer() {
  const [updateParent, { loading, error, called }] = useMutation<
  UpdateParentCustomer,
  UpdateParentCustomerVariables
  >(UpdateParentCustomerMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });
  const updateParentCustomer = (fields: UpdateParentCustomerVariables, successCb?: () => void) => {
    updateParent({
      variables: { ...fields },
      onCompleted: ({ updateParentCustomer: updatedParentCustomer }) => {
        if (updatedParentCustomer.parentCustomer) {
          notificationService.open({
            title: 'Link Parent Account',
            text: 'Parent account successfully linked',
            type: 'success',
          });
        } else {
          notificationService.open({
            title: 'Remove Parent Account',
            text: 'Parent account successfully delinked',
            type: 'success',
          });
        }
        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    updateParentCustomer,
    isLoadingUpdateParentCustomer: loading,
    errorUpdateParentCustomer: error,
    isUpdateParentCustomerWasCalled: called,
  } as const;
}
